// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.feedback_section .FeedTags {
  box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.0509803922);
  border-radius: 10px;
  overflow: hidden;
}
.feedback_section .FeedTags .card-header .icon {
  color: #0060ce;
}
.feedback_section .FeedTags .tags-list {
  margin: 0;
  padding: 0;
}
.feedback_section .FeedTags .tags-list li.list-inline-item {
  margin-bottom: 10px;
}
.feedback_section .FeedTags .tags-list li.list-inline-item:last-child {
  margin-bottom: 0;
}
.feedback_section .FeedTags .tags-list li.list-inline-item a {
  color: #212529;
  font-size: 13px;
  padding: 0.5rem 0.75rem;
  border-radius: 5px;
  background: #f7f7f7;
  text-decoration: none;
  display: flex;
  align-items: center;
}
.feedback_section .FeedTags .tags-list li.list-inline-item a i {
  color: #d1cece;
  font-size: 1.2rem;
}
.feedback_section .FeedTags .tags-list li.list-inline-item a:hover, .feedback_section .FeedTags .tags-list li.list-inline-item a.active {
  background: #dbdada;
}
.feedback_section .FeedTags .tags-list li.list-inline-item a:hover i, .feedback_section .FeedTags .tags-list li.list-inline-item a.active i {
  color: #6c757d;
}
.feedback_section .FeedTags .emoji-list {
  margin: 0;
  padding: 0;
}
.feedback_section .FeedTags .emoji-list li.list-inline-item {
  margin-bottom: 10px;
  margin-right: 10px;
}
.feedback_section .FeedTags .emoji-list li.list-inline-item:last-child {
  margin-bottom: 0;
  margin-right: 0;
}
.feedback_section .FeedTags .emoji-list li.list-inline-item a {
  border-bottom: 2px solid transparent;
  padding: 1rem 0.4rem;
}
.feedback_section .FeedTags .emoji-list li.list-inline-item a:hover, .feedback_section .FeedTags .emoji-list li.list-inline-item a.active {
  border-bottom: 2px solid #212529;
}
.feedback_section .FeedTags .feedbackType-list {
  margin: 0;
  padding: 0;
}
.feedback_section .FeedTags .feedbackType-list li.list-inline-item {
  margin-bottom: 10px;
  margin-right: 10px;
}
.feedback_section .FeedTags .feedbackType-list li.list-inline-item:last-child {
  margin-bottom: 0;
  margin-right: 0;
}
.feedback_section .FeedTags .feedbackType-list li.list-inline-item a {
  color: #212529;
  font-size: 14px;
  padding: 0.8rem 2rem;
  border-radius: 25px;
  background: #f7f7f7;
  text-decoration: none;
}
.feedback_section .FeedTags .feedbackType-list li.list-inline-item a:hover, .feedback_section .FeedTags .feedbackType-list li.list-inline-item a.active {
  color: #ffffff;
  background: #212529;
}`, "",{"version":3,"sources":["webpack://./src/student_module/components/feedback/_feedback.scss"],"names":[],"mappings":"AAAA;EACI,oDAAA;EACA,mBAAA;EACA,gBAAA;AACJ;AACI;EACI,cAAA;AACR;AAEI;EACI,SAAA;EACA,UAAA;AAAR;AAEQ;EAEI,mBAAA;AADZ;AAGY;EACI,gBAAA;AADhB;AAIY;EACI,cAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;AAFhB;AAIgB;EACI,cAAA;EACA,iBAAA;AAFpB;AAKgB;EAEI,mBAAA;AAJpB;AAMoB;EACI,cAAA;AAJxB;AAWI;EACI,SAAA;EACA,UAAA;AATR;AAWQ;EACI,mBAAA;EACA,kBAAA;AATZ;AAWY;EACI,gBAAA;EACA,eAAA;AAThB;AAYY;EACI,oCAAA;EACA,oBAAA;AAVhB;AAYgB;EAEI,gCAAA;AAXpB;AAiBI;EACI,SAAA;EACA,UAAA;AAfR;AAiBQ;EACI,mBAAA;EACA,kBAAA;AAfZ;AAiBY;EACI,gBAAA;EACA,eAAA;AAfhB;AAkBY;EACI,cAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,mBAAA;EACA,qBAAA;AAhBhB;AAkBgB;EAEI,cAAA;EACA,mBAAA;AAjBpB","sourcesContent":[".feedback_section .FeedTags {\n    box-shadow: 0px 3px 20px #0000000D;\n    border-radius: 10px;\n    overflow: hidden;\n\n    .card-header .icon {\n        color: #0060ce;\n    }\n\n    .tags-list {\n        margin: 0;\n        padding: 0;\n\n        li.list-inline-item {\n\n            margin-bottom: 10px;\n\n            &:last-child {\n                margin-bottom: 0;\n            }\n\n            a {\n                color: #212529;\n                font-size: 13px;\n                padding: 0.5rem 0.75rem;\n                border-radius: 5px;\n                background: #f7f7f7;\n                text-decoration: none;\n                display: flex;\n                align-items: center;\n\n                i {\n                    color: #d1cece;\n                    font-size: 1.2rem;\n                }\n\n                &:hover,\n                &.active {\n                    background: #dbdada;\n\n                    i {\n                        color: #6c757d;\n                    }\n                }\n            }\n        }\n    }\n\n    .emoji-list {\n        margin: 0;\n        padding: 0;\n\n        li.list-inline-item {\n            margin-bottom: 10px;\n            margin-right: 10px;\n\n            &:last-child {\n                margin-bottom: 0;\n                margin-right: 0;\n            }\n\n            a {\n                border-bottom: 2px solid transparent;\n                padding: 1rem 0.4rem;\n\n                &:hover,\n                &.active {\n                    border-bottom: 2px solid #212529;\n                }\n            }\n        }\n    }\n\n    .feedbackType-list {\n        margin: 0;\n        padding: 0;\n\n        li.list-inline-item {\n            margin-bottom: 10px;\n            margin-right: 10px;\n\n            &:last-child {\n                margin-bottom: 0;\n                margin-right: 0;\n            }\n\n            a {\n                color: #212529;\n                font-size: 14px;\n                padding: 0.8rem 2rem;\n                border-radius: 25px;\n                background: #f7f7f7;\n                text-decoration: none;\n\n                &:hover,\n                &.active {\n                    color: #ffffff;\n                    background: #212529;\n                }\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
